import React from 'react';
import './App.css';
import {
  Col,
  Container,
  FormLabel,
  ListGroup,
  ListGroupItem,
  Row,
  Stack,
} from 'react-bootstrap';
import { Dialog, Fab, Snackbar } from '@mui/material';
import NavBar from './Component/navbar';
import { useState } from 'react';
import { useDrop } from 'react-dnd';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Player from './Component/TextInput';
import FieldComponent from './Component/FieldComponent';
import Recorder from './Component/Recorder';
import { useSpeechContext } from '@speechly/react-client';

// import { Globe, Microphone } from 'phosphor-react';
// import { clear } from '@testing-library/user-event/dist/clear';
function App() {
  const { segment, listening, attachMicrophone, start, stop } = useSpeechContext();
  // eslint-disable-next-line
  const [players, setPlayer] = useState([
    { name: 'Label' },
    { name: 'Paragragh' },
    { name: 'Voice Response' },
    { name: 'Video Response' },
    { name: 'Multiple Choice' },
    { name: 'Yes/No ' },
    { name: 'Date Picker' },
    { name: 'Rating' },
  ]);
  // eslint-disable-next-line
  const [field, setField] = useState([
    { name: 'Label', type: 'Label' },
    { name: 'Paragragh', type: 'text' },
    { name: 'Voice Response', type: 'voice' },
    { name: 'Video Response', type: 'video' },
    { name: 'Multiple Choice', type: 'choice' },
    { name: 'Yes/No ', type: 'yes' },
    { name: 'Date Picker', type: 'date' },
    { name: 'Rating', type: 'rating' },
  ]);
  const [team, setTeam] = useState([]);
  // eslint-disable-next-line
  const [{ isOver }, addToTeamRef] = useDrop({
    accept: 'player',
    collect: monitor => ({ isOver: !!monitor.isOver() }),
  });
  const [{ isOver: isPlayerOver }, removeFromTeamRef] = useDrop({
    accept: 'team',
    collect: monitor => ({ isOver: !!monitor.isOver() }),
  });
  const movePlayerToTeam = item => {
    console.log(item);
    setPlayer(prev => prev.filter((_, i) => item.index !== i));
    setTeam(prev => [...prev, item]);
  };
  const removePlayerFromTeam = item => {
    setTeam(prev => prev.filter((_, i) => item.index !== i));
    setPlayer(prev => [...prev, item]);
  };
  const [command,setCommand] = useState("");
  const [Textline,setTextline] = useState("");
//speech commands
const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;
const recorder = new SpeechRecognition();

recorder.continous = true;
recorder.interimResults = true;
recorder.lang = "en-US";

function startRecording() {
  recorder.start();
  recorder.onstart = () =>
   
  recorder.onresult = event => {
    if (event.results[0].isFinal) {
      const string = event.results[0][0].transcript;
      if (string.length) {
      
        setCommand(string)
        console.log(string,"hik")
        processCommand(string)
         
      }
    } else console.log("not lis");
  };
  // Start listening again on end
  recorder.onend = () => {
    console.log("ended")
   recorder.start();

  
  };

  // Handle user declined audio permissions error
  recorder.onerror = err => {
    if (err.error === "not-allowed")
      alert("Please allow Microphone access"
      );
  };
};
function processCommand(strings) {
  console.log("enter")
  switch (strings) {
    case "open":
      console.log("open window");
    //  window.location.href("www.google.com");
      
      break;
    case "write":
      setCommand("")
      setTextline(command)
      break;
    default:
      break;
  }
  recorder.start();
}

  return (
    <div className="App">
      <NavBar />
      <Container>
   
          <Col xs={6} md={9}>
            {' '}
            <Container>
              <Form>
                <Container>
                  <h3 color="#fff">Form Builder</h3>
                  <p>{Textline}</p>
                  <Button onClick={() => startRecording()} >Rec</Button>
                  <ListGroup>
                    <ListGroupItem
                      className="boxshadow"
                      style={{ height: '600px' }}
                      bgGradient={
                        isPlayerOver
                          ? 'linear(to-b, yellow.300, yellow.500)'
                          : 'linear(to-b, yellow.100, yellow.200)'
                      }
                      ref={addToTeamRef}
                     
                      >
                      <FormLabel>What is your Name ?</FormLabel>
                      {team.map((p, i) => (
                        <FieldComponent
                          item={p}
                          key={i}
                          playerType="team"
                          onDropPlayer={removePlayerFromTeam}
                          index={i}
                        />
                      ))}
                    </ListGroupItem>
                  </ListGroup>

                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Container>
              </Form>
            </Container>
          </Col>
          <Col xs={6} md={3}>
            {' '}
            <div className="HeaderName">Form Elements</div>
            <Stack className="boxshadow">
              <ListGroupItem
                bgGradient={
                  isPlayerOver
                    ? 'linear(to-b, yellow.300, yellow.500)'
                    : 'linear(to-b, yellow.100, yellow.200)'
                }
                ref={removeFromTeamRef}
                p="4"
                minH="70vh"
                boxShadow="xl"
                borderRadius="md">
                {field.map((p, i) => (
                  <Player
                    item={p}
                    key={i}
                    playerType="player"
                    onDropPlayer={movePlayerToTeam}
                    index={i}
                  />
                ))}
              </ListGroupItem>
            </Stack>
          </Col>
        
        {/* <Snackbar
        open={open}
        onClose={handleClose}
        TransitionComponent={transition}
        message="I love snacks"
        key={transition ? transition.name : ''}
      /> */}
        <Fab className='fab-css' color='primary' >
        <Recorder/>
        </Fab>
      </Container>
    </div>
  );
}

export default App;
